"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Directory/Sidebar/List/Users/Item.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);



var _peers = require('shared/selectors/peers');
var _org = require('shared/selectors/org');



var _entities = require('shared/transforms/entities');
var _hooks = require('web/services/hooks');

var _GenericItem = require('web/screens/Directory/Sidebar/List/GenericItem'); var _GenericItem2 = _interopRequireDefault(_GenericItem);







const UserItem = ({ userKey, orgKey, isViewed }) => {
  const org = _hooks.useAppSelector.call(void 0, state => _org.selectOrgByKey.call(void 0, orgKey, state))
  const user = _hooks.useAppSelector.call(void 0, state => _peers.selectUserByKey.call(void 0, state, userKey))
  const userEntity = _react.useMemo.call(void 0, 
    () => {
      // SAFETY: the one key is orgKey, and its value is the org stored under it.
      const orgsMap = (org ? { [orgKey]: org } : {}) 
      return user
        ? _entities.mapUserToEntity.call(void 0, 
          orgsMap,
          _entities.makeSpecificOrgTitleUserDescription.call(void 0, orgKey),
        )(user)
        : null
    },
    [org, orgKey, user],
  )

  return (
    _react2.default.createElement(_GenericItem2.default, {
      entity: userEntity,
      orgKey: orgKey,
      isViewed: isViewed, __self: this, __source: {fileName: _jsxFileName, lineNumber: 39}}
    )
  )
}

exports. default = _react.memo.call(void 0, UserItem)
